import { defineStore } from 'pinia'

export const useChatStore = defineStore('chat', {
    state: () => ({
        unread_count:0,
        access_time:null,
        loading:false,
        error:null,
    }),
    actions: {
        async fetchUnreadCount() {
            try {
                //負荷を下げるためせめて15分に1回にする
                let now_time = new Date();
                if ((this.access_time != null) && (this.access_time.getTime() + (1000*60*15) > now_time.getTime())) {
                    return;
                }
                //posts を初期化（ストアのインスタンスには this でアクセス）
                this.access_time = now_time;
                this.unread_count = 0
                //loading を true に
                this.loading = true
                await fetch((<HTMLInputElement>document.getElementById('chat_apis_user_chat_unread_count')).value,{
                    headers: {
                        'Tokiwa-Api-Key': <string>(document.getElementsByName('tokiwa_api_key').length == 0 ? '' : (!document.getElementsByName('tokiwa_api_key')[0].getAttribute('content') ? "" :  document.getElementsByName('tokiwa_api_key')[0].getAttribute('content'))),
                    }
                })
                .then((response) => response.json())
                .then((data) => {
                    this.unread_count = data.count;
                    let elem = document.getElementById('chat_unread_count');
                    if (elem != null) {
                        if (this.unread_count > 0) {
                            elem.innerText = this.unread_count;
                            elem.style.display="block";
                        } else {
                            elem.style.display="none";
                        }
                    }
                });
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        }
    }
})
